import { MailAddressForm } from "@/shared/components/text-box/mail-address-form";
import { BaseSnackBarContext } from "@/shared/components/snack-bar/base-snack-bar-context";
import { FixedWebWidthContentWrapper } from "@/shared/components/page/fixed-web-width-content-wrapper";
import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { LoginHeader } from "@/shared/components/header/login-header";
import { Footer } from "@/shared/components/footer/footer";

export const SignUpDone = () => {
 const navigate = useNavigate();

  const location = useLocation();
  const snackBarMessage = (location.state as string) ?? "";
  const { openBaseSnackBar } = useContext(BaseSnackBarContext);
  useEffect(() => {
    if (snackBarMessage !== "") {
      openBaseSnackBar(snackBarMessage);
    }
  }, [snackBarMessage]);

  // localStorageから認証に用いたメールアドレスとルートを取得
  const storedEmail = localStorage.getItem("signUpEmail") || "";
  const storedAuthType = localStorage.getItem("signUpAuthType") || "0";
  localStorage.removeItem("signUpEmail");
  localStorage.removeItem("signUpAuthType");

  // 表示文言の設定
  const title = 
    storedAuthType === "1" ? "メールアドレス認証" : "新しいアカウントの作成";
  const message =
    storedAuthType === "1"
      ? <><p>認証メールを送信しました</p><p>受信したメールを開いて記載のURLをクリックすると認証が完了し、Web版をご利用いただけます。</p></>
      : <p>仮登録メールを送信しました</p>;
  const stepClassNames =
    storedAuthType === "1"
      ? "auth-completed"
      : "";

  // メールアドレスフォームに付与するID
  const mailAddressFormId = "mail_address_form_id";
  // やり直しボタンに付与するID
  const retryButtonId = "btnRetrySignUp";

  return (
    <>
      <LoginHeader content={title} />
      <main>
        <section id="signUp" className={stepClassNames}>
          <nav className="step">
            {storedAuthType === "1" ? (
              <ol>
                <li className="active">認証メールを送信</li>
                <li className="">認証完了</li>
              </ol>
            ) : (
              <ol>
                <li className="active">仮登録メールを送信</li>
                <li>パスワードの設定</li>
                <li>ユーザー名の設定</li>
                <li>登録完了</li>
              </ol>
            )}
          </nav>
          {message}
          <ul className="form">
            <li>
              <MailAddressForm
                className="signUpMail"
                id={mailAddressFormId}
                initialValue={storedEmail}
                title="メールアドレス"
                isReadOnly={true}
              />
            </li>
          </ul>
          <div className="notice">
            <p>メールサーバー上で自動的に、"迷惑メール"などの通常使用しているフォルダ以外に送信される場合がありますのでご注意ください。</p>
            <p>URL付きメールが受信拒否になっている場合や、ドメイン指定などでの受信設定の影響で届かない場合があります。「@mail.sorimachi.co.jp」のドメインを受信できるようご自身で設定ください。</p>
          </div>
          <nav className="btns">
            <BaseRoundButton
              className="btn-base"
              id={retryButtonId}
              buttonText="やり直す"
              onClick={() => navigate(-1)}
              isActive={true}
            />
          </nav>
        </section>
      </main>
      <Footer />
    </>
  );
};
